<template>
    <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <img
                class="mx-auto h-12 w-auto"
                src="@/assets/logo-full.png"
                alt="upyield logo"
            >
            <h2 class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
                Forgot Password
            </h2>
        </div>

        <div
            v-loading="isLoading"
            class="bg-white mt-8 py-8 px-4 shadow sm:rounded-lg sm:px-10 sm:mx-auto sm:w-full sm:max-w-md"
        >
            <form @submit.prevent="resetPassword">
                <div>
                    <form-field
                        v-model="email"
                        :field="{
                            name: 'email',
                            type: 'email',
                            label: 'Email address',
                            validate: 'required|email',
                        }"
                    />
                </div>

                <div class="mt-6">
                    <span class="block w-full rounded-md shadow-sm">
                        <button
                            type="submit"
                            class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-700 hover:bg-primary-500 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition duration-150 ease-in-out"
                        >
                            Reset password
                        </button>
                    </span>
                </div>
            </form>

            <div class="mt-6">
                <div class="relative">
                    <div class="absolute inset-0 flex items-center">
                        <div class="w-full border-t border-gray-300" />
                    </div>
                    <div class="relative flex justify-center text-sm leading-5">
                        <span class="px-2 bg-white text-gray-500">
                            or
                        </span>
                    </div>
                </div>

                <div class="mt-6 grid grid-cols-2 gap-4">
                    <div>
                        <span class="w-full inline-flex rounded-md shadow-sm">
                            <router-link
                                :to="{ name: 'Login' }"
                                class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out"
                            >
                                Login
                            </router-link>
                        </span>
                    </div>

                    <div>
                        <span class="w-full inline-flex rounded-md shadow-sm">
                            <router-link
                                :to="{ name: 'Register' }"
                                class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out"
                            >
                                Register
                            </router-link>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { ref } from '@vue/composition-api';
import Message from 'shared-lib/helpers/message';
import api from '@/api';
import useValidator from '@/composables/useValidator';
import FormField from 'shared-lib/components/forms/FormField.vue';

export default defineComponent({
    name: 'Login',
    components: { FormField },
    setup (props, { root: { $validator } }) {
        useValidator();

        const email = ref('');
        const isLoading = ref(false);

        function resetPassword () {
            $validator.validateAll().then((result) => {
                if (result) {
                    isLoading.value = true;
                    api.resetPassword({
                        email: email.value,
                    })
                        .then(() => Message.success({ message: 'Reset password link has been sent.' }))
                        .catch((e) => console.log(e)) // eslint-disable-line no-console
                        .finally(() => isLoading.value = false);
                }
            });
        }

        return {
            resetPassword,
            email,
            isLoading,
        };
    },
});
</script>

<style lang="scss">
.Login .navigation {
    display: none;
}
</style>
